export const POSTHOG_PROXY_PATH = '/relay';

const DEFAULT_POSTHOG_HOST = 'https://eu.i.posthog.com';

const trimHost = (host) =>
  (host || DEFAULT_POSTHOG_HOST).trim().replace(/\/+$/, '');

export const posthogAssetsHost = (host) =>
  trimHost(host).replace('.i.posthog.com', '-assets.i.posthog.com');

export const posthogUiHost = (host) =>
  trimHost(host).replace('.i.posthog.com', '.posthog.com');

export const posthogRewrites = (host) => [
  {
    source: `${POSTHOG_PROXY_PATH}/static/:path*`,
    destination: `${posthogAssetsHost(host)}/static/:path*`
  },
  {
    source: `${POSTHOG_PROXY_PATH}/array/:path*`,
    destination: `${posthogAssetsHost(host)}/array/:path*`
  },
  {
    source: `${POSTHOG_PROXY_PATH}/:path*`,
    destination: `${trimHost(host)}/:path*`
  }
];

export const isPosthogProxyPath = (pathname) =>
  pathname === POSTHOG_PROXY_PATH ||
  pathname.startsWith(`${POSTHOG_PROXY_PATH}/`);
